import { render, staticRenderFns } from "./BatteryHeap2.vue?vue&type=template&id=3b4de956&scoped=true&"
import script from "./BatteryHeap2.vue?vue&type=script&lang=js&"
export * from "./BatteryHeap2.vue?vue&type=script&lang=js&"
import style0 from "./BatteryHeap2.vue?vue&type=style&index=0&id=3b4de956&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4de956",
  null
  
)

export default component.exports